export default "__VITE_ASSET__CkPvj9JZ__"